export * from './window-type-6.component';